import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { IAdvizeDataFactory } from './i-advize-data-factory.service';
import { CommonModule } from '@angular/common';

export function getIAdvizeData(injector: Injector): () => void {
  const result = () => {
    const factory = injector.get(IAdvizeDataFactory);
    factory.build();
  };
  return result;
}

@NgModule({
  imports: [CommonModule],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: getIAdvizeData,
      deps: [Injector],
      multi: true,
    },
  ],
})
export class IAdvizeDataModule {}
